import React, { useEffect, useState, useCallback } from 'react';
import { IEPSchedule } from '../../interfaces/EPSchedule';
import IPageProps from '../../interfaces/page';
import FooterPage from '../footer';
import TopNavPage1 from '../topNav1';
import * as XLSX from 'xlsx';

import { ObjectModal } from '../../components/modal/objectmodal';
import { handleLink } from '../../modules/utils';
import { checkFileExists } from '../../services/DrFileService';
import { Dev, announcementClassName, currentClass, devTolPrint, getLoginInfo } from './tool/helper';
import ScheduleDB from './component/scheduleDB';
import { getAdNewByClass } from '../../services/EP/EpScheduleService';
import ContactModal from './tool/contactModal';
import { getEPApplyByNo } from '../../services/EP/EpLoginService';
import { IApplyFormData, IGroupInfo } from '../../interfaces/EpModal';
import { getDrGroupPrimeByYrApplyNoWithDetail, getDrGroupAward, getDrGroupAwardWithDetail } from '../../services/EP/EPApplyGroupService';
import { getGroupListPass } from '../../services/EP/EPApplyGroupService';
import TeamAwardsTable from './modal/TeamAwardsTableModal';
import ResultPresentationModal from './tool/resultPresentation';
import ReporterSpecialAwardModal from './component/ReporterSpecialAwardModal';
import { checkFeatureEnabled } from '../../services/EP/DrEnabledService';
import { getCurrentCompetitionInfo } from '../../services/EP/EpScheduleService';
export interface NewsItem {
    Context: string; // 內容
    SendDate: string; // 發送日期 (ISO 8601 格式)
    TopNews: boolean; // 是否為置頂新聞
}

const EpMainPage: React.FunctionComponent<IPageProps> = (props) => {
    const [currentTypeShow, setCurrentTypeShow] = useState<string | null>(null);
    const [isCurrentGrShow, setIsCurrentGrShow] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showResultModal, setShowResultModal] = useState<boolean>(false);
    const [showTeamModal, setShowTeamModal] = useState<boolean>(false);
    const [showFinalistModal, setShowFinalistModal] = useState<boolean>(false);
    const [currentFinalistType, setCurrentFinalistType] = useState<string | null>(null);
    const [showAwardModal, setShowAwardModal] = useState<boolean>(false);
    const [currentAwardType, setCurrentAwardType] = useState<string | null>(null);
    const [iSec, setIsec] = useState<IEPSchedule[]>([]);
    const [openObjModal, setOpenObjModal] = useState(false);
    const [isDisplay, setIsDisplay] = useState(false);
    const [NewsItemList, setNewItemList] = useState<NewsItem[]>([]);
    const [applyInfo, setApplyInfo] = useState<IApplyFormData>();
    const [errorCount, setErrorCount] = useState(0);
    const [showReporterModal, setShowReporterModal] = useState(false);
    const [isExportingHonor, setIsExportingHonor] = useState(false);
    const [showTeamListSection, setShowTeamListSection] = useState<boolean>(false);
    const [showFinalistSection, setShowFinalistSection] = useState<boolean>(false);
    const [showAwardSection, setShowAwardSection] = useState<boolean>(false);

    const awardGroups = [
        { id: 'awardA', label: '國小A組' },
        { id: 'awardB', label: '國小B組' },
        { id: 'awardC', label: '國中C組' },
        { id: 'awardD', label: '國中D組' }
    ];
    // 檢查所有區塊功能是否開啟
    const checkAllSectionsEnabled = useCallback(async () => {
        try {
            console.log('=== 檢查所有區塊功能狀態 ===');
            console.log('初始 currentClass 值:', currentClass);
            
            let actualClassYear = currentClass;
            
            // 如果 currentClass 還沒設定，直接從 API 獲取
            if (currentClass === '--') {
                console.log('currentClass 尚未設定，直接從 API 獲取...');
                try {
                    const competInfo = await getCurrentCompetitionInfo() as any;
                    if (competInfo && competInfo.length > 0) {
                        actualClassYear = competInfo[0].Class.trim();
                        console.log('從 API 獲取的年度:', actualClassYear);
                    }
                } catch (apiError) {
                    console.error('獲取競賽資訊失敗:', apiError);
                }
            }
            
            // 最終使用的年度（如果還是沒有，使用預設值）
            const classYear = actualClassYear !== '--' ? actualClassYear : '115年度';
            console.log('最終使用的年度參數:', classYear);
            
            // 檢查各個區塊
            const teamListEnabled = await checkFeatureEnabled('報名審核通過的小隊', classYear);
            const finalistEnabled = await checkFeatureEnabled('決賽名單', classYear);
            const awardEnabled = await checkFeatureEnabled('決賽獲獎隊伍', classYear);
            
            console.log('各區塊功能狀態:', {
                '報名審核通過的小隊': teamListEnabled,
                '決賽名單': finalistEnabled,
                '決賽獲獎隊伍': awardEnabled
            });
            
            // 設定各區塊狀態
            setShowTeamListSection(teamListEnabled);
            setShowFinalistSection(finalistEnabled);
            setShowAwardSection(awardEnabled);
            
            console.log('✅ 所有區塊狀態已更新');
        } catch (error) {
            console.error('檢查區塊功能狀態失敗:', error);
            // 預設全部關閉
            setShowTeamListSection(false);
            setShowFinalistSection(false);
            setShowAwardSection(false);
        }
    }, []);

    useEffect(() => {
        getInfoFrNewAdByClass(); // 取得小組通過名單
        setCurrentTypeShow('');
        checkAllSectionsEnabled(); // 檢查所有區塊功能是否開啟
    }, [checkAllSectionsEnabled]);

    const getDateRange = (bdate: string, edate: string): String => {
        let result = '';
        result = bdate.slice(6, 7) + '~' + edate.slice(9, 10);
        return result;
    };
    const getInfoFrNewAdByClass = async () => {
        let rsp = (await getAdNewByClass(announcementClassName)) as NewsItem[];
        setNewItemList(rsp);
    };

    const handlecheck = () => {
        const result = checkFileExists('upload113/EP001-01', 'EP001-01.pdf', '1');
        console.log(result);
    };
    const [currentLoginInfo, setCurrentLoginInfo] = useState<any>();
    /**  取資料 */
    const fetchDataGroup = useCallback(async (): Promise<IGroupInfo[]> => {
        let currentLoginInfo = getLoginInfo();
        setCurrentLoginInfo(currentLoginInfo);
        // let GroupDataList = (await getDrGroupPrimeByYrApplyNo(currentClass, currentLoginInfo.LoginID)) as IGroupInfo[];
        let GroupDataList = (await getDrGroupPrimeByYrApplyNoWithDetail(currentClass, currentLoginInfo.LoginID)) as IGroupInfo[];

        // 初始化錯誤計數
        let errorTotal = 0;

        // 遍歷 GroupDataList，檢查 TeacherCount 和 StudentCount
        GroupDataList.forEach((group) => {
            if (validateRsInfo(group.TeacherCount, group.StudentCount)) {
                errorTotal += 1; // 如果有錯誤則累加
            }
        });

        // 更新 errorCount
        setErrorCount(errorTotal);

        return GroupDataList;
    }, []);

    const validateRsInfo = (teacherCount: number = 0, studentCount: number = 0) => {
        let result = '';
        if (!teacherCount) {
            result += '教師至少需要一位 ';
        }

        if (studentCount > 4 || studentCount < 3) {
            result += '小隊成員需3-4位 ';
        }

        return result;
    };
    useEffect(() => {
        const fetchData = async () => {
            let groupList = await fetchDataGroup();
        };
        getEPApplyByLoginID(sessionStorage.getItem('LoginID') + '');
        fetchData();

        // 設定定時檢查所有區塊功能狀態（每5分鐘檢查一次）
        const intervalId = setInterval(() => {
            checkAllSectionsEnabled();
        }, 5 * 60 * 1000); // 5分鐘 = 5 * 60 * 1000 毫秒

        // 清理定時器
        return () => {
            clearInterval(intervalId);
        };
    }, [checkAllSectionsEnabled, fetchDataGroup]);

    /** 取得登入者基本資訊 (申請者)*/
    const getEPApplyByLoginID = async (loginID: string) => {
        let rsp = await getEPApplyByNo(loginID);
        // alert(JSON.stringify(rsp))
        setApplyInfo(rsp[0] as IApplyFormData);
    };

    // 匯出榮譽榜 Excel 功能
    const handleExportHonorList = async () => {
        console.log('榮譽榜匯出按鈕被點擊');
        
        // 防止重複點擊
        if (isExportingHonor) {
            return;
        }
        
        setIsExportingHonor(true);
        
        try {
            // 使用包含詳細資訊的API
            console.log('準備調用 getDrGroupAwardWithDetail API');
            const awardData = await getDrGroupAwardWithDetail() as any[];
            console.log('API返回資料:', awardData);
            
            if (!awardData || awardData.length === 0) {
                alert('目前沒有獲獎隊伍資料可匯出');
                return;
            }

            // 組別對應表，確保與首頁顯示一致
            const groupTypeMapping: { [key: string]: string } = {
                'A': '國小A組',
                '國小A組': '國小A組',
                'B': '國小B組', 
                '國小B組': '國小B組',
                'C': '國中C組',
                '國中C組': '國中C組',
                'D': '國中D組',
                '國中D組': '國中D組'
            };

            // 轉換資料格式為Excel所需格式
            const excelData = awardData.map((item: any) => ({
                '獎項': item.Prize || '',
                '組別': groupTypeMapping[item.Type] || item.Type || '',
                '小隊編號': item.Groupno || '',
                '小隊名稱': item.Groupname || '',
                '學校名稱': item.SchFullName || item.Schoolname || '',
                '指導老師1': item.Teacher1 || '',
                '指導老師2': item.Teacher2 || '',
                '學生1': item.Student1 || '',
                '學生2': item.Student2 || '',
                '學生3': item.Student3 || '',
                '學生4': item.Student4 || ''
            }));

            // 創建工作簿
            const ws = XLSX.utils.json_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '榮譽榜');

            // 設定欄位寬度
            const colWidths = [
                { wch: 12 }, // 獎項
                { wch: 12 }, // 組別
                { wch: 15 }, // 小隊編號
                { wch: 20 }, // 小隊名稱
                { wch: 25 }, // 學校名稱
                { wch: 15 }, // 指導老師1
                { wch: 15 }, // 指導老師2
                { wch: 12 }, // 學生1
                { wch: 12 }, // 學生2
                { wch: 12 }, // 學生3
                { wch: 12 }  // 學生4
            ];
            ws['!cols'] = colWidths;

            // 生成檔案名稱（包含當前日期）
            const currentDate = new Date().toISOString().slice(0, 10);
            const fileName = `榮譽榜_${currentDate}.xlsx`;

            // 下載檔案
            XLSX.writeFile(wb, fileName);
            
        } catch (error) {
            console.error('匯出榮譽榜失敗:', error);
            alert('匯出榮譽榜失敗，請稍後再試');
        } finally {
            // 無論成功或失敗都要重置載入狀態
            setIsExportingHonor(false);
        }
    };

    // 打開決賽名單新視窗 - 按組別分組顯示
    const openFinalistWindow = async () => {
        const fetchResult = (await getGroupListPass()) as any[];

        // 篩選決賽名單 (FlagRevOk = 1)
        const finalistData = fetchResult.filter((item: any) => item.FlagRevOk == '1' && !item.GroupNo?.includes('test') && !item.GroupNo?.includes('Test'));

        // 按組別分組
        const groupedFinalists = finalistData.reduce((acc: any, item: any) => {
            const groupType = item.GroupTypeStr || '未分組';
            if (!acc[groupType]) {
                acc[groupType] = [];
            }
            acc[groupType].push(item);
            return acc;
        }, {});

        // 對每個組別按 FinalOrder 排序
        Object.keys(groupedFinalists).forEach((groupType) => {
            groupedFinalists[groupType].sort((a: any, b: any) => {
                const orderA = parseInt(a.FinalOrder) || 999;
                const orderB = parseInt(b.FinalOrder) || 999;
                return orderA - orderB;
            });
        });

        const newWindow = window.open('', '_blank', 'width=1200,height=800,scrollbars=yes');
        if (newWindow) {
            let htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>決賽名單</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        .group-section { margin-bottom: 30px; }
                        .group-title { 
                            color: #007bff; 
                            font-size: 20px; 
                            font-weight: bold; 
                            border-left: 4px solid #007bff; 
                            padding-left: 10px; 
                            margin-bottom: 15px; 
                        }
                        .team-count { color: #666; font-size: 14px; margin-bottom: 10px; }
                        table { border-collapse: collapse; width: 100%; margin-bottom: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; font-weight: bold; }
                        tr:nth-child(even) { background-color: #f9f9f9; }
                    </style>
                </head>
                <body>
                    <h1>決賽名單</h1>
                    <p>產生時間：${new Date().toLocaleString()}</p>
            `;

            Object.keys(groupedFinalists).forEach((groupType) => {
                const teams = groupedFinalists[groupType];
                htmlContent += `
                    <div class="group-section">
                        <div class="group-title">${groupType} - 決賽名單</div>
                        <div class="team-count">入選隊數：${teams.length} 組</div>
                        <table>
                            <thead>
                                <tr>
                                    <th>順序</th>
                                    <th>小隊編號</th>
                                    <th>小隊名稱</th>
                                    <th>探究主題</th>
                                    <th>指導老師</th>
                                    <th>學校</th>
                                </tr>
                            </thead>
                            <tbody>
                `;

                teams.forEach((item: any) => {
                    htmlContent += `
                        <tr>
                            <td>${item.FinalOrder || '-'}</td>
                            <td>${item.GroupNo || '-'}</td>
                            <td>${item.GroupName || '-'}</td>
                            <td>${item.Topic || '-'}</td>
                            <td>${item.TeacherName || '-'}</td>
                            <td>${item.SchoolName || '-'}</td>
                        </tr>
                    `;
                });

                htmlContent += `
                            </tbody>
                        </table>
                    </div>
                `;
            });

            htmlContent += `
                </body>
                </html>
            `;

            newWindow.document.write(htmlContent);
            newWindow.document.close();
        }
    };

    // 打開 TeamAwards 資料查詢新視窗
    const openTeamAwardsWindow = async () => {
        const fetchResult = (await getGroupListPass()) as any[];

        // 篩選掉測試資料
        const validData = fetchResult.filter((item: any) => !item.GroupNo?.includes('test') && !item.GroupNo?.includes('Test'));

        // 統計各組別數量
        const groupStats = validData.reduce((acc: any, item: any) => {
            const groupType = item.GroupTypeStr || '未分組';
            acc[groupType] = (acc[groupType] || 0) + 1;
            return acc;
        }, {});

        const newWindow = window.open('', '_blank', 'width=1200,height=800,scrollbars=yes');
        if (newWindow) {
            let htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>TeamAwards 資料查詢</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        .stats { background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-bottom: 20px; }
                        table { border-collapse: collapse; width: 100%; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; font-weight: bold; position: sticky; top: 0; }
                        tr:nth-child(even) { background-color: #f9f9f9; }
                        .flag-ok-1 { background-color: #d4edda; }
                        .flag-ok-0 { background-color: #f8d7da; }
                    </style>
                </head>
                <body>
                    <h1>TeamAwards 資料查詢</h1>
                    <div class="stats">
                        <h3>資料統計</h3>
                        <p>總隊數：${validData.length} 組</p>
                        <p>各組別統計：</p>
                        <ul>
            `;

            Object.keys(groupStats).forEach((groupType) => {
                htmlContent += `<li>${groupType}：${groupStats[groupType]} 組</li>`;
            });

            htmlContent += `
                        </ul>
                        <p>產生時間：${new Date().toLocaleString()}</p>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>組別類型</th>
                                <th>小隊編號</th>
                                <th>小隊名稱</th>
                                <th>探究主題</th>
                                <th>指導老師</th>
                                <th>學校</th>
                                <th>順序</th>
                                <th>決賽入選</th>
                            </tr>
                        </thead>
                        <tbody>
            `;

            validData.forEach((item: any) => {
                const flagRevOkClass = item.FlagRevOk == '1' ? 'flag-ok-1' : 'flag-ok-0';
                htmlContent += `
                    <tr class="${flagRevOkClass}">
                        <td>${item.GroupTypeStr || '-'}</td>
                        <td>${item.GroupNo || '-'}</td>
                        <td>${item.GroupName || '-'}</td>
                        <td>${item.Topic || '-'}</td>
                        <td>${item.TeacherName || '-'}</td>
                        <td>${item.SchoolName || '-'}</td>
                        <td>${item.FinalOrder || '-'}</td>
                        <td>${item.FlagRevOk == '1' ? '是' : '否'}</td>
                    </tr>
                `;
            });

            htmlContent += `
                        </tbody>
                    </table>
                </body>
                </html>
            `;

            newWindow.document.write(htmlContent);
            newWindow.document.close();
        }
    };

    return (
        <>
            <TopNavPage1 />
            {/* {devTolPrint(applyInfo)} */}
            <div className="section pt-3 pt-lg-5">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center flex-column flex-xl-row">
                        <h5 className="title mb-3 me-3">
                            線上探究<div className="ms-2">EP,Explore Process</div>
                        </h5>
                        <div className="mx-auto ms-auto me-md-0 text-center">
                            <a className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button" onClick={() => handleLink('/epabout')}>
                                EP 說明
                            </a>
                            <a href="/epFAQ" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button">
                                常見問題
                            </a>
                            <div className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" data-bs-toggle="modal" onClick={() => setOpenObjModal(true)} data-bs-target="#plan">
                                實施計畫
                            </div>
                            {/* <a href="/epresult" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button"  onClick={() => setShowResultModal(true)} >
                            歷年成果</a>   */}

                            <a href="/epresult" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button" onClick={(e) => { e.preventDefault(); handleLink('/epresult'); }}>
                                歷年成果
                            </a>
                            {/* <a href="/epExcellent" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button" onClick={(e) => { e.preventDefault(); handleLink('/epExcellent'); }}>
                            特優作品
                            </a> */}
                            {/* <a href="epExcellent.html" class="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button">
                            特優作品</a> */}

                            <div className="btn btn-outline-secondary btn-round text-nowrap" data-bs-toggle="modal" data-bs-target="#plan3" onClick={() => setShowModal(true)}>
                                活動聯絡
                            </div>
                        </div>
                    </div>
                    <div className="text-center h4">
                        {' '}
                        <h3>
                            <b>歡迎參加{currentClass}柯華葳線上數位閱讀專題探究競賽</b>
                        </h3>
                    </div>
                    <ScheduleDB />
                    <div className=" mt-3 mb-3 me-3" style={{ fontWeight: 900, color: '#f7a779', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        {Dev.showText(applyInfo)}
                    </div>
                    <div className="card p-3 p-md-4">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center justify-content-center text-second bg-second text-center border-radius-sm mb-3 fw-bolder" style={{ width: '180px' }}>
                                競賽公告
                                {/* <div dangerouslySetInnerHTML={{ __html: '<a href="https://example.com">Website</a>' }} /> */}
                            </div>
                            <div className="flex-item mx-auto ms-auto me-md-0 text-center">
                                <a href="/eplogin" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button">
                                    登入(承辦人、學生和指導老師分別以編號登入)
                                </a>
                                <a href="/epNewPage" className="btn btn-outline-secondary btn-round text-nowrap me-2 me-sm-3" type="button">
                                    承辦人申請
                                </a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <ol className="text-dblue text-justify">
                                    {NewsItemList.map((item) => {
                                        return (
                                            <>
                                                <li dangerouslySetInnerHTML={{ __html: item.Context || '' }}></li>
                                            </>
                                        );
                                    })}
                                    {/* <li>【活動預告】{currentClass}柯華葳線上探究競賽預計於2025/2/11開放報名，敬請期待！</li>
                        <li>開放「探究學習」，報名後可選擇只參與學習或競賽，實施方式詳見「附件一：探究學習之說明」。</li>
                        <li>完成簽名之「參賽聲明書」留校備查即可，無須回傳。</li>
                        <li>「探究歷程階段3、4、5」合併在同一時間開始與完成。</li>
                        <li>決賽舉辦時間遇天然災害停班停課的因應措施，詳見十二(四)條。</li> */}
                                </ol>
                            </div>
                            <div className="col-12 col-lg-6">
                                <img src="./assets/img/ep/114用圖.jpeg" alt="" className="w-100" />
                            </div>
                        </div>
                    </div>

                    {/* 競賽相關區塊 - 根據時間控制顯示 */}
                    
                    <div className="row mt-4">
                        {/* 報名審核通過的小隊 - 根據時間控制顯示 */}
                        {showTeamListSection && (
                            <div className="col-12 col-lg-4 mb-3">
                                <div className="card p-3 p-md-4 h-100">
                                    <div className="text-second bg-second text-center border-radius-sm mb-3 fw-bolder" style={{ width: '180px' }}>
                                        報名審核通過的小隊
                                    </div>
                                    <div className="d-flex flex-column flex-lg-row justify-content-between flex-wrap">
                                        {awardGroups.map((group) => (
                                            <div
                                                key={group.id}
                                                className="text-second dots pointer"
                                                onClick={() => {
                                                    setCurrentTypeShow(group.label);
                                                    setShowTeamModal(true);
                                                }}
                                            >
                                                ● {group.label}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 決賽名單 - 根據時間控制顯示 */}
                        {showFinalistSection && (
                            <div className="col-12 col-lg-4 mb-3">
                                <div className="card p-3 p-md-4 h-100">
                                    <div className="text-second bg-second text-center border-radius-sm mb-3 fw-bolder" style={{ width: '180px' }}>
                                        決賽名單
                                    </div>
                                <div className="d-flex flex-column flex-lg-row justify-content-between flex-wrap">
                                    {awardGroups.map((group) => (
                                        <div
                                            key={group.id}
                                            className="text-second dots pointer"
                                            onClick={() => {
                                                setCurrentFinalistType(group.label);
                                                setShowFinalistModal(true);
                                            }}
                                        >
                                            ● {group.label}
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex flex-column flex-lg-row mx-auto text-second my-3">
                                    <div className="my-3 my-lg-0 me-4 pointer" data-bs-toggle="modal" data-bs-target="#special">
                                        <a href="/assets/doc/114年度學校榮譽榜.pdf" target="_blank" className="pointer text-decoration-none text-second">
                                            <span className="material-icons-outlined me-2" style={{ verticalAlign: 'sub' }}>
                                                thumb_up_alt
                                            </span>
                                            榮譽榜
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        {/* 決賽獲獎隊伍 - 根據時間控制顯示 */}
                        {showAwardSection && (
                            <div className="col-12 col-lg-4 mb-3">
                                <div className="card p-3 p-md-4 h-100">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="text-second bg-second text-center border-radius-sm fw-bolder" style={{ width: '180px' }}>
                                            決賽獲獎隊伍
                                        </div>
                                    <button 
                                        className={`btn btn-outline-success btn-sm ${isExportingHonor ? 'disabled' : ''}`}
                                        onClick={handleExportHonorList}
                                        disabled={isExportingHonor}
                                        title={isExportingHonor ? "正在匯出榮譽榜..." : "匯出榮譽榜Excel"}
                                    >
                                        {isExportingHonor ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                匯出中...
                                            </>
                                        ) : (
                                            <>
                                                <span className="material-icons-outlined me-1" style={{ fontSize: '16px' }}>
                                                    download
                                                </span>
                                                榮譽榜
                                            </>
                                        )}
                                    </button>
                                </div>
                                <div className="d-flex flex-column flex-lg-row justify-content-between flex-wrap">
                                    {awardGroups.map((group) => (
                                        <div
                                            key={group.id}
                                            className="text-second dots pointer"
                                            onClick={() => {
                                                setCurrentAwardType(group.label);
                                                setShowAwardModal(true);
                                            }}
                                        >
                                            ● {group.label}
                                        </div>
                                    ))}
                                </div>
                                <div className="row row-cols-1 row-cols-md-2 g-3 my-3 text-second">
                                    <div className="col">
                                        <a
                                            href="/assets/doc/114年度潛力獎得獎隊伍.pdf"
                                            target="_blank"
                                            className="link-chip d-inline-flex align-items-center gap-2 text-decoration-none text-second text-nowrap"
                                        >
                                            <span className="material-icons-outlined" style={{ verticalAlign: 'sub' }}>
                                                thumb_up_alt
                                            </span>
                                            潛力獎
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a
                                            href="#"
                                            className="link-chip d-inline-flex align-items-center gap-2 text-decoration-none text-second text-nowrap"
                                            onClick={e => { e.preventDefault(); setShowReporterModal(true); }}
                                        >
                                            <span className="material-icons-outlined" style={{ verticalAlign: 'sub' }}>
                                                thumb_up_alt
                                            </span>
                                            報導者特別獎
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a
                                            href="/assets/doc/114年柯華葳線上數位閱讀專題探究競賽國小組總評.pdf"
                                            target="_blank"
                                            className="link-chip d-inline-flex align-items-center gap-2 text-decoration-none text-second text-nowrap"
                                        >
                                            <span className="material-icons-outlined" style={{ verticalAlign: 'sub' }}>
                                                thumb_up_alt
                                            </span>
                                            競賽總評(國小組)
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a
                                            href="/assets/doc/114年柯華葳線上數位閱讀專題探究競賽國中組總評.pdf"
                                            target="_blank"
                                            className="link-chip d-inline-flex align-items-center gap-2 text-decoration-none text-second text-nowrap"
                                        >
                                            <span className="material-icons-outlined" style={{ verticalAlign: 'sub' }}>
                                                thumb_up_alt
                                            </span>
                                            競賽總評(國中組)
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
            </div>

            <ContactModal show={showModal} handleClose={() => setShowModal(false)} />
            <ResultPresentationModal show={showResultModal} handleClose={() => setShowResultModal(false)} />
            <ObjectModal title="實施計畫" isOpen={openObjModal} setOpenModal={setOpenObjModal} objectURL={`./imagedoc/${currentClass}柯華葳線上數位閱讀專題探究學習與競賽實施計畫.pdf`} />
            <ReporterSpecialAwardModal show={showReporterModal} onClose={() => setShowReporterModal(false)} />

            {/* 小隊名單彈出視窗 */}
            {showTeamModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowTeamModal(false)}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{currentTypeShow} - 報名審核通過的小隊</h5>
                                <button type="button" className="btn-close" onClick={() => setShowTeamModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <TeamAwardsTable type={currentTypeShow} ishidden={false} onClose={() => setShowTeamModal(false)} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowTeamModal(false)}>
                                    關閉
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 決賽名單彈出視窗 */}
            {showFinalistModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowFinalistModal(false)}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{currentFinalistType} - 決賽名單</h5>
                                <button type="button" className="btn-close" onClick={() => setShowFinalistModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <TeamAwardsTable type={currentFinalistType} ishidden={false} onClose={() => setShowFinalistModal(false)} filterFlagRevOk={true} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowFinalistModal(false)}>
                                    關閉
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 決賽獲獎隊伍彈出視窗 */}
            {showAwardModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowAwardModal(false)}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{currentAwardType} - 決賽獲獎隊伍</h5>
                                <button type="button" className="btn-close" onClick={() => setShowAwardModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <TeamAwardsTable type={currentAwardType} ishidden={false} onClose={() => setShowAwardModal(false)} filterAwarded={true} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAwardModal(false)}>
                                    關閉
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <FooterPage />
        </>
    );
};

export default EpMainPage;
